import React from "react";
import styled from "styled-components";
import {
  Users,
  Calendar,
  DollarSign,
  MessageCircle,
  BookOpen,
  BarChart2,
  Settings,
  Smartphone,
} from "lucide-react";

const FeaturesSection = () => {
  const features = [
    {
      icon: <Users size={32} color="#f97316" />,
      title: "Member & Leadership Management",
      description:
        "Track members, leaders, groups, and roles. Keep your congregation organized and connected.",
    },
    {
      icon: <DollarSign size={32} color="#f97316" />,
      title: "Contributions & Pledges",
      description:
        "Record giving, pledges, and fundraising with detailed reports and audit trails.",
    },
    {
      icon: <BarChart2 size={32} color="#f97316" />,
      title: "Church Accounting",
      description:
        "Manage expenses, budgets, and accounts with built-in fund accounting tailored for churches.",
    },
    {
      icon: <Calendar size={32} color="#f97316" />,
      title: "Event & Attendance Tracking",
      description:
        "Create events, monitor attendance, and keep your church calendar organized and visible.",
    },
    {
      icon: <MessageCircle size={32} color="#f97316" />,
      title: "Bulk SMS & Communication",
      description:
        "Send updates, reminders, and devotionals through integrated bulk SMS tools (Cloud & Team editions).",
    },
    {
      icon: <BookOpen size={32} color="#f97316" />,
      title: "Ministry & Service Scheduling",
      description:
        "Organize worship teams, volunteers, and ministry service schedules easily.",
    },
    {
      icon: <Smartphone size={32} color="#f97316" />,
      title: "Groups & Role-Based Access",
      description:
        "Organize church groups efficiently and control access levels securely, optimizing collaboration and confidentialit",
    },
    {
      icon: <Settings size={32} color="#f97316" />,
      title: "Customizable & Expandable",
      description:
        "Integrate with M-PESA, SMS, or other APIs on request. Tailor it to your unique church processes.",
    },
  ];

  return (
    <Wrapper id="features">
      <div className="container">
        <Title>Powerful Features for Every Church</Title>
        <SubTitle>
          CS Church Management Software equips your ministry with the right tools to serve better, grow stronger, and stay organized.
        </SubTitle>
        <Grid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <IconWrapper>{feature.icon}</IconWrapper>
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </FeatureCard>
          ))}
        </Grid>
      </div>
    </Wrapper>
  );
};

export default FeaturesSection;

// Styled Components
const Wrapper = styled.section`
  padding: 80px 0;
  background-color: #fff;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 10px;
`;

const SubTitle = styled.p`
  text-align: center;
  max-width: 750px;
  margin: 0 auto 50px;
  font-size: 16px;
  color: #555;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 30px;
`;

const FeatureCard = styled.div`
  background-color: #f9fafb;
  padding: 30px 25px;
  border-radius: 16px;
  text-align: left;
  box-shadow: 0 4px 10px rgba(0,0,0,0.03);
  transition: 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background-color: #fff;
    box-shadow: 0 6px 16px rgba(0,0,0,0.05);
  }

  h4 {
    margin: 15px 0 10px;
    font-size: 18px;
    font-weight: 700;
  }

  p {
    font-size: 14px;
    color: #555;
    line-height: 1.5;
  }
`;

const IconWrapper = styled.div`
  margin-bottom: 12px;
`;

